
export default {
  name: 'DealCard',
  props: {
    deal: {
      type: Object,
      required: true,
    },
    titleTag: {
      type: String,
      default: 'h3',
    },
  },
  computed: {
    images() {
      return (this.deal.preview_images || []).slice(0, 3)
    },
  },
}
